import { transSizeToKB } from '@/src/tools/helper';

/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-23 15:37:06
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-23 16:20:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/util.ts
 */
import { IMAGE_EXT, VIDEO_EXT } from './config';
import { handleOnFormatStoreTimeAndDateWithTimezone } from '@/src/tools/tools';

export const getInfoFromFile = (infoName, infoProp, file) => {
  switch (infoName) {
    case 'File Type': {
      const props = file[infoProp];
      const type: string = props ? props.replace(/.*\./, '') : '';
      return `${type.toUpperCase()} ${
        IMAGE_EXT.indexOf(type) !== -1
          ? 'image'
          : VIDEO_EXT.indexOf(type) !== -1
          ? 'video'
          : ''
      }`;
    }
    case 'File Size': {
      const value = transSizeToKB(file[infoProp]);
      return value;
    }
    case 'Dimension': {
      const width = file[infoProp[0]];
      const height = file[infoProp[1]];
      return `${width} by ${height} px`;
    }
    case 'Uploaded at': {
      const date = handleOnFormatStoreTimeAndDateWithTimezone(file[infoProp]);
      return date;
    }
    default:
      return file[infoProp];
  }
};
